import { jsx as l, jsxs as O } from "react/jsx-runtime";
import { c as k } from "react/compiler-runtime";
import { Box as g, Tooltip as F, IconButton as v, Paper as z } from "@mui/material";
import B from "@mui/icons-material/Visibility";
import T from "@mui/icons-material/VisibilityOff";
import E from "@mui/icons-material/Fullscreen";
import b from "@mui/icons-material/FullscreenExit";
import { mapContainerStyles as i } from "../styles.js";
import { Workspaces as H, WorkspacesOutlined as V } from "@mui/icons-material";
const D = (S) => {
  const o = k(23), {
    isOverlayHidden: a,
    onOverlayVisibilityToggle: p,
    miniControlsMainStyles: u,
    onFullscreenToggle: C,
    isFullscreen: d,
    showFullscreenToggle: w,
    showCirclesControl: x,
    setShowCircles: h,
    showCircles: e,
    hasOverlays: y
  } = S, I = w === void 0 ? !0 : w;
  let r;
  o[0] !== u ? (r = u ?? {}, o[0] = u, o[1] = r) : r = o[1];
  let n;
  o[2] !== r ? (n = {
    ...i.miniControlsPaper,
    ...r
  }, o[2] = r, o[3] = n) : n = o[3];
  let t;
  o[4] !== d || o[5] !== C || o[6] !== I ? (t = I && /* @__PURE__ */ l(g, { sx: i.miniControlsRow, children: /* @__PURE__ */ l(F, { title: d ? "Exit Fullscreen" : "Enter Fullscreen", children: /* @__PURE__ */ l(v, { onClick: C, size: "small", color: d ? "primary" : "default", sx: i.miniControlButton, children: d ? /* @__PURE__ */ l(b, { sx: i.miniControlIcon }) : /* @__PURE__ */ l(E, { sx: i.miniControlIcon }) }) }) }), o[4] = d, o[5] = C, o[6] = I, o[7] = t) : t = o[7];
  let s;
  o[8] !== h || o[9] !== e || o[10] !== x ? (s = x && /* @__PURE__ */ l(F, { title: `${e ? "Hide" : "Expand"} Radio Groups`, children: /* @__PURE__ */ l(v, { onClick: () => h?.(!e), size: "small", color: e ? "primary" : "default", sx: i.miniControlButton, children: e ? /* @__PURE__ */ l(H, { fontSize: "small" }) : /* @__PURE__ */ l(V, { fontSize: "small" }) }) }), o[8] = h, o[9] = e, o[10] = x, o[11] = s) : s = o[11];
  let c;
  o[12] !== y || o[13] !== a || o[14] !== p ? (c = y && /* @__PURE__ */ l(F, { title: a ? "Show Overlay" : "Hide Overlay", children: /* @__PURE__ */ l(v, { onClick: p, size: "small", color: a ? "primary" : "default", sx: i.miniControlButton, children: a ? /* @__PURE__ */ l(B, { sx: i.miniControlIcon }) : /* @__PURE__ */ l(T, { sx: i.miniControlIcon }) }) }), o[12] = y, o[13] = a, o[14] = p, o[15] = c) : c = o[15];
  let m;
  o[16] !== s || o[17] !== c ? (m = /* @__PURE__ */ l(g, { sx: i.expandedControls, children: /* @__PURE__ */ O(g, { sx: i.miniControlsGroup, children: [
    s,
    c
  ] }) }), o[16] = s, o[17] = c, o[18] = m) : m = o[18];
  let f;
  return o[19] !== n || o[20] !== t || o[21] !== m ? (f = /* @__PURE__ */ O(z, { elevation: 2, sx: n, children: [
    t,
    m
  ] }), o[19] = n, o[20] = t, o[21] = m, o[22] = f) : f = o[22], f;
};
export {
  D as default
};
